import { Injectable } from '@angular/core';
import { ArticleRef, Cart, CartType, OrderType, PermissionResult } from '../../../../core/model';
import { Occ } from '../../../../core/occ/occ-models';
import { Converter, ConverterService, hasRequiredProperties } from '../../../../core/util';
import { ORDER_ENTRY_NORMALIZER } from './converters';

@Injectable({ providedIn: 'root' })
export class CartNormalizer implements Converter<Occ.Cart | undefined, Cart | undefined> {
  constructor(private converter: ConverterService) {}

  convert(source?: Occ.Cart): Cart | undefined {
    return source ? this.convertCart(source) : undefined;
  }

  private convertCart(source: Occ.Cart): Cart | undefined {
    if (!hasRequiredProperties(source, ['code'])) {
      return undefined;
    }
    const { cartType, orderType, invisibleItems, removedItems, pyOrderParameters, entries, permissionResults, ...target } =
      source;
    const notifications = [];
    if (!!pyOrderParameters?.smallOrderFeeHeadsUpMessage) {
      notifications.push({
        icon: 'info-circle',
        text: pyOrderParameters.smallOrderFeeHeadsUpMessage,
      });
    }

    const convertedEntries = this.converter.convertMany(entries, ORDER_ENTRY_NORMALIZER);

    let prePrintedLabelEntryMixedWithNonPrePrintedEntry = false;

    if (cartType === CartType.stock) {
      const entriesWithPrePrintedLabel = convertedEntries?.filter((entry) => entry.prePrintedLabel?.code);
      prePrintedLabelEntryMixedWithNonPrePrintedEntry =
        entriesWithPrePrintedLabel?.length > 0 && entriesWithPrePrintedLabel?.length !== convertedEntries?.length;
    }

    return {
      ...target,
      deliveryAddress: pyOrderParameters?.shipTo,
      entries: convertedEntries,
      cartType: cartType as CartType,
      orderType: OrderType[orderType],
      notifications,
      invisibleItems: this.convertArticles(invisibleItems),
      removedItems: this.convertArticles(removedItems),
      cartPermissionResults: permissionResults as PermissionResult[],
      prePrintedLabelEntryMixedWithNonPrePrintedEntry: prePrintedLabelEntryMixedWithNonPrePrintedEntry,
    };
  }

  private convertArticles(source: Occ.ArticleRef[]): ArticleRef[] {
    return source ? source.map((c) => c.code) : [];
  }
}
